/* Rizelune — interacciones propias */
(function () {
  if (window.rzLoaded) return;
  window.rzLoaded = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.rz-reveal:not(.rz-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('rz-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('rz-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-rz-parallax]');
    if (!imgs.length || reduce) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var k = parseFloat(img.getAttribute('data-rz-parallax')) || 0;
        var r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        img.style.setProperty('--rz-parallax', (-r.top * k / 100).toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initCounters() {
    var nums = document.querySelectorAll('[data-rz-count]');
    if (!nums.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-rz-count')) || 0;
      if (reduce) { el.textContent = target; return; }
      var start = null, dur = 1600;
      function step(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function initGallery() {
    document.querySelectorAll('[data-rz-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-rz-main]');
      if (!main) return;
      var vid = g.querySelector('[data-rz-main-video]');
      g.querySelectorAll('[data-rz-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          g.querySelectorAll('[data-rz-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var vsrc = btn.getAttribute('data-video');
          main.style.opacity = 0;
          if (vid) vid.style.opacity = 0;
          setTimeout(function () {
            if (vsrc && vid) {
              main.hidden = true;
              vid.hidden = false;
              if (vid.getAttribute('src') !== vsrc) { vid.poster = btn.getAttribute('data-poster') || ''; vid.src = vsrc; }
              vid.setAttribute('aria-label', btn.getAttribute('data-alt') || '');
              vid.style.opacity = 1;
              var p = vid.play(); if (p && p.catch) p.catch(function () {});
              return;
            }
            if (vid) { vid.pause(); vid.hidden = true; }
            main.hidden = false;
            main.src = btn.getAttribute('data-src');
            main.srcset = '';
            main.alt = btn.getAttribute('data-alt') || '';
            main.style.opacity = 1;
          }, 180);
        });
      });
    });
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var comma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var dot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return (format || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, dot);
  }

  function initVariants() {
    document.querySelectorAll('[data-rz-product]').forEach(function (root) {
      var dataEl = root.querySelector('[data-rz-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var format = root.getAttribute('data-money-format');
      var selects = root.querySelectorAll('[data-rz-option]');
      var idInputs = document.querySelectorAll('[data-rz-variant-id]');
      var price = root.querySelectorAll('[data-rz-price]');
      var old = root.querySelectorAll('[data-rz-compare]');
      var buttons = document.querySelectorAll('[data-rz-add]');
      function update() {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variants.find(function (x) {
          return x.options.every(function (o, i) { return o === chosen[i]; });
        });
        buttons.forEach(function (b) {
          b.disabled = !v || !v.available;
          var label = b.querySelector('[data-rz-label]');
          if (label) label.textContent = !v ? b.getAttribute('data-unavailable') : (v.available ? b.getAttribute('data-add') : b.getAttribute('data-soldout'));
        });
        if (!v) return;
        idInputs.forEach(function (i) { i.value = v.id; });
        price.forEach(function (p) { p.textContent = formatMoney(v.price, format); });
        old.forEach(function (o) {
          o.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price, format) : '';
        });
        if (v.featured_image) {
          var main = root.querySelector('[data-rz-main]');
          if (main) { main.src = v.featured_image.src; main.srcset = ''; main.hidden = false; }
          var mv = root.querySelector('[data-rz-main-video]');
          if (mv) { mv.pause(); mv.hidden = true; }
        }
      }
      selects.forEach(function (s) { s.addEventListener('change', update); });
    });
  }

  function initQty() {
    document.querySelectorAll('[data-rz-qty]').forEach(function (q) {
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(input.value, 10) || 1;
          n += b.getAttribute('data-step') === 'up' ? 1 : -1;
          input.value = Math.max(1, n);
        });
      });
    });
  }

  function initPacks() {
    document.querySelectorAll('[data-rz-packs]').forEach(function (box) {
      var form = box.closest('product-form');
      var qty = form && form.querySelector('[data-rz-pack-qty]');
      var total = form && form.querySelector('[data-rz-pack-total]');
      var isMain = form && form.querySelector('[data-rz-main-form]');
      box.querySelectorAll('input[type=radio]').forEach(function (r) {
        r.addEventListener('change', function () {
          box.querySelectorAll('.rz-pack').forEach(function (l) { l.classList.toggle('is-active', l.contains(r)); });
          if (qty) qty.value = r.value;
          if (total) total.textContent = '· ' + r.getAttribute('data-price');
          if (isMain) document.querySelectorAll('[data-rz-sticky] [data-rz-price]').forEach(function (p) { p.textContent = r.getAttribute('data-price'); });
        });
        if (r.checked && isMain) document.querySelectorAll('[data-rz-sticky] [data-rz-price]').forEach(function (p) { p.textContent = r.getAttribute('data-price'); });
      });
    });
  }

  function initUpsell() {
    if (window.rzUpsellReady) return;
    window.rzUpsellReady = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rz-upsell]');
      if (!b) return;
      var line = b.getAttribute('data-line');
      var input = document.getElementById('Drawer-quantity-' + line) || document.getElementById('Quantity-' + line);
      if (!input) return;
      b.disabled = true;
      input.value = b.getAttribute('data-qty');
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function initRitual() {
    if (window.rzRitualReady) return;
    window.rzRitualReady = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rz-ritual]');
      if (!b) return;
      e.preventDefault();
      var items;
      try { items = JSON.parse(b.getAttribute('data-items')); } catch (err) { return; }
      var box = b.closest('.rz-ritual__item, .rz-ritual, .rz-packcard, .rz-estrella__body');
      var errBox = box && box.querySelector('[data-rz-ritual-err]');
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      b.disabled = true;
      if (errBox) errBox.hidden = true;
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || 'error');
          if (drawer && typeof drawer.renderContents === 'function' && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
          else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rz-ritual', cartData: res });
        })
        .catch(function () { if (errBox) errBox.hidden = false; })
        .finally(function () { b.disabled = false; });
    });
  }

  function initPopup() {
    var pop = document.querySelector('[data-rz-pop]');
    if (!pop || pop.dataset.ready) return;
    pop.dataset.ready = '1';
    var KEY = 'rz-pop', CART_KEY = 'rz-pop-cart', CART_DAYS = 3;
    function read(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
    function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
    var subscribed = !!(read(KEY) || {}).ok;
    var form = pop.querySelector('form');
    var err = pop.querySelector('[data-rz-pop-err]');
    var teaser = document.querySelector('[data-rz-pop-open]');
    var excluded = /\/(cart|checkouts?|account|challenge|policies)(\/|$)/.test(location.pathname);
    var lastFocus = null;
    function step(name) {
      pop.querySelectorAll('[data-rz-pop-step]').forEach(function (s) { s.hidden = s.getAttribute('data-rz-pop-step') !== name; });
    }
    function showTeaser(on) {
      if (!teaser) return;
      if (on && !subscribed && !excluded) { teaser.hidden = false; requestAnimationFrame(function () { teaser.classList.add('is-in'); }); }
      else { teaser.classList.remove('is-in'); teaser.hidden = true; }
    }
    function open(ok) {
      if (!pop.hidden) return;
      lastFocus = document.activeElement;
      step(ok ? 'ok' : 'form');
      showTeaser(false);
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      var f = pop.querySelector(ok ? '.rz-pop__code' : 'input[type=email]');
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 300);
    }
    function close() {
      pop.classList.remove('is-open');
      setTimeout(function () { pop.hidden = true; showTeaser(true); }, 350);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-rz-pop-close]')) close();
      var c = e.target.closest('[data-rz-copy]');
      if (c) {
        var code = c.getAttribute('data-rz-copy');
        var label = c.querySelector('[data-rz-copy-label]');
        var done = function () { if (label) label.textContent = c.getAttribute('data-copied'); };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
      }
    });
    if (teaser) teaser.addEventListener('click', function () { open(false); });
    // Enlaces «Apúntate y llévate un 10 %» (franja de avisos, ficha): abren la ventana; si ya se apuntó, le enseña su código
    document.addEventListener('click', function (e) {
      var l = e.target.closest('[data-rz-pop-link], a[href$="#rz-bienvenida"]');
      if (!l) return;
      e.preventDefault();
      open(subscribed);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    if (form) form.addEventListener('submit', function () {
      var btn = form.querySelector('[type=submit]');
      if (btn) setTimeout(function () { btn.disabled = true; }, 0);
    });
    // Al volver de enviar el formulario (Shopify recarga la página con #rz-pop-form)
    if (location.hash === '#rz-pop-form') {
      if (location.search.indexOf('customer_posted=true') > -1) { save(KEY, { ok: 1, t: Date.now() }); subscribed = true; open(true); return; }
      if (pop.querySelector('[data-rz-pop-has-error]')) { open(false); if (err) err.hidden = false; }
    }
    if (subscribed || excluded) return;
    // Botón pequeño en la esquina
    setTimeout(function () { if (pop.hidden) showTeaser(true); }, 2500);
    // Una vez, al añadir al carrito (si no hay ya un pack con descuento), cuando se cierra el carrito
    if (pop.getAttribute('data-after-cart') !== 'true' || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    var pending = false;
    function canAfterCart() {
      var last = read(CART_KEY);
      try { if (sessionStorage.getItem(CART_KEY)) return false; } catch (e) {}
      return !subscribed && !(last && Date.now() - last.t < CART_DAYS * 864e5);
    }
    function markAfterCart() {
      save(CART_KEY, { t: Date.now() });
      try { sessionStorage.setItem(CART_KEY, '1'); } catch (e) {}
    }
    function waitDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.classList.contains('active')) { setTimeout(waitDrawer, 700); return; }
      setTimeout(function () {
        if (drawer && drawer.classList.contains('active')) { waitDrawer(); return; }
        pending = false;
        if (canAfterCart() && pop.hidden) { markAfterCart(); open(false); }
      }, 600);
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (!ev || ev.source !== 'product-form' || pending || !canAfterCart()) return;
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart.item_count || cart.total_discount > 0) return;
        pending = true;
        setTimeout(waitDrawer, 1200);
      }).catch(function () {});
    });
  }

  function initStickyBuy() {
    var bar = document.querySelector('[data-rz-sticky]');
    var anchor = document.querySelector('[data-rz-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var on = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-shown', on);
      document.body.classList.toggle('rz-sticky-on', on);
    }).observe(anchor);
    var btn = bar.querySelector('[data-rz-sticky-btn]');
    if (btn) btn.addEventListener('click', function () {
      var main = document.querySelector('[data-rz-main-form] [type=submit]');
      if (main) main.click();
    });
  }

  function initQuick() {
    var bar = document.querySelector('[data-rz-quick]');
    if (!bar || bar.getAttribute('data-ready')) return;
    bar.setAttribute('data-ready', '1');
    try { if (sessionStorage.getItem('rz-quick-off')) return; } catch (e) {}
    bar.hidden = false;
    var blocked = [];
    function update() {
      var on = window.scrollY > window.innerHeight * 0.85 && blocked.length === 0 && !document.body.classList.contains('rz-quick-off');
      bar.classList.toggle('is-shown', on);
      document.body.classList.toggle('rz-sticky-on', on);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var i = blocked.indexOf(e.target);
          if (e.isIntersecting && i < 0) blocked.push(e.target);
          if (!e.isIntersecting && i >= 0) blocked.splice(i, 1);
        });
        update();
      }, { threshold: 0.12 });
      document.querySelectorAll('.rz-buy, .rz-ofertas, .rz-catalogo, .rz-footer, .footer').forEach(function (b) { io.observe(b); });
    }
    window.addEventListener('scroll', update, { passive: true });
    var close = bar.querySelector('[data-rz-quick-close]');
    if (close) close.addEventListener('click', function () {
      document.body.classList.add('rz-quick-off');
      try { sessionStorage.setItem('rz-quick-off', '1'); } catch (e) {}
      update();
    });
    update();
  }

  function init() {
    initQuick();
    initReveal(); initParallax(); initCounters(); initGallery(); initVariants(); initQty(); initPacks(); initUpsell(); initRitual(); initPopup(); initStickyBuy();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
